import { dataProps } from './properties'

export const setLeaveApplicationList = (state, payload) => {
    state.list = payload.response
    state.nav.total = payload.total
state.nav.page_number = payload.page_number
if(!state.nav.had_results) {
   state.nav.had_results = payload.total>0
}
}    

export const setLeaveApplicationData = (state, payload) => {
    state.props = payload
} 

export const resetLeaveApplicationData = state => {
    state.props = JSON.parse(JSON.stringify(dataProps))
}


// WEBPACK FOOTER //
// ./src/store/modules/leaveApplication/mutations.js